<template>
  <div class="state-div">
    <div class="state-box">
      <div class="item time-left">
        <div class="item-box1">
          <img class="header-icon" :src="personalInfo.photo" />
        </div>
        <div class="item-box1 item-box2">
          <div class="info-intergral">
            <router-link tag="p" class="item-ling" to="IntegralDetail">
              <b class="van-ellipsis">{{this.$store.state.integralAll}}</b>
              <br />
              <i>积分</i>
            </router-link>
            <router-link tag="p" to="/stepCount">
              <b class="van-ellipsis">{{this.$store.state.stepAll}}</b>
              <br />
              <i>步数</i>
            </router-link>
          </div>
        </div>
      </div>
      <div class style="text-align: right;">
        <van-cell title="个人中心" is-link url="/personalCenter" />
      </div>
    </div>
    <div class="text-index">
      <b>{{personalInfo.name}}</b>
      <div class="item-textp1">
        {{personalInfo.unionName}}
        <span v-if="personalInfo.deptName">&gt;{{personalInfo.deptName}}</span>
      </div>
    </div>
    <div class="state-item-box">
      <van-row type="flex" justify="center" gutter="10">
        <van-col span="12" v-for="(item,index) in itemModel" :key="index">
          <router-link :to="item.enterPage">
            <img :src="item.itemUrl" />
          </router-link>
        </van-col>
      </van-row>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import Vue from "vue";
// import {mapState} from "vuex";
export default {
  props: {
    personalInfo: {
      //个人积分，名称及总步数
      type: Object
    }
  },
  data() {
    return {
      itemModel: [
        //四个模块图片配置
        {
          itemUrl: require("../../../assets/images/ghfw.png"),
          enterPage: "/ghService"
        },
        {
          itemUrl: require("../../../assets/images/ghtwh.png"),
          enterPage: "/consultList"
        },
        {
          itemUrl: require("../../../assets/images/dcwq.png"),
          enterPage: "/questionList"
        },
        {
          itemUrl: require("../../../assets/images/zxfl@2x.png"),
          enterPage: "/shoppingMall"
        }
      ]
    };
  },
  // computed:{
  //     ...mapState(['integralAll'])
  // },
  created() {},
  methods: {}
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../../assets/stylus/theme.styl';
@import '../../../assets/stylus/reset.css';

.info-intergral {
  display: flex;
  background: #F5F6FB;
  border-radius: 19px;
  border: 1px solid #CCD7EC;
  text-align: center;
  font-size: 0;
  padding: 4px 0;

  .item-ling {
    border-right: 1px solid #CCD7EC;
  }

  p {
    flex: 1;
  }

  i {
    font-size: 11px !important;
  }
}

.text-index {
  font-size: 14px;
  font-weight: 500;
  color: $text-black;
  display: flex;
  padding: 0 60px 0 10px;
  margin-bottom: 10px;
  overflow: hidden;

  b {
    width: 50px;
    display: inline-block;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
  }
}

.state-item-box {
  padding: 10px 10px 0;

  img {
    width: 100%;
  }

  >>>.van-row--justify-center {
    flex-wrap: wrap;
  }

  >>>.van-col {
    margin-bottom: 10px;
  }
}

.item-textp1 {
  // text-overflow: ellipsis;
  // display: -webkit-box;
  // -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 14px;
  letter-spacing: 1px;
  margin-left: 20px;
  flex: 1;
}

a {
  color: #B2B2B2;
}

.state-div {
  margin-top: 10px;
  background: #fff;
}

.state-box {
  display: flex;
  align-items: center;
  padding: 10px 10px 5px;

  .header-icon {
    width: 40px;
    vertical-align: middle;
    height: 40px;
    border: 1px solid #fff;
    border-radius: 50px;
  }

  .time-left {
    flex: 2 !important;
    color: #353535;
    font-weight: bold;

    .item-box1 {
      display: inline-block;
    }

    b {
      font-size: 13px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #29B79F;
      display: inline-block;
      margin-bottom: 5px;
      width: 68%;
    }

    .item-box2 {
      vertical-align: middle;
      margin-left: 15px;
      font-size: 12px;
      color: $text-black;
      overflow: hidden;
      width: 57%;

      .item-textp1 {
        margin-top: 5px;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        font-size: 14px;
        line-height: 19px;
        letter-spacing: 1px;
      }
    }

    .text-color {
      color: #B2B2B2;
    }
  }

  .item {
    flex: 1;

    .state-title {
      margin: auto 10px;
      color: #888888;
    }
  }
}

.state-detail-info {
  position: relative;

  .state-detail-box {
    display: flex;
    align-items: center;
    text-align: center;
    margin: 10px 20px 0;
    justify-content: center;

    .detail-item {
      flex: 1;
      background: #fff;
      padding: 10px 10px 0;
      border-radius: 5px;
      color: #BBC3CE;
      font-size: 14px;

      .item-left {
        text-align: center;
        line-height: 0.6rem;
        color: $text-black;
      }

      .state-num {
        color: #353535;
        font-weight: bold;
        font-size: 22px;
        position: relative;
        margin-bottom: 5px;
      }
    }
  }
}
</style>